<template>
  <SideBar>
    <template #side-bar-activator>
      <Activator class="self-centered cursor-e-resize" :key="`side_bar_activator>`" @mousedown.native="$router.push({
        name: $route.matched[1].name,
      })" />
    </template>
    <template #content>
      <v-spacer />
      <TText value="Extend Workpackage" font_weigth="400" :size="15" />
      <StandardFlexBox max_height="100px" height="100px">
        <Waggon @click.native="extendWorkpackageWithNewWaggon()" :workpackage_count="1" :zoom="2" style="cursor: pointer;">
          <template #content>
            <div class="token-view" style="cursor: pointer; font-size: large;">
              <TText value="New Wagon" />
            </div>
            <!-- extend_workpackage -->
            <Workpackage :workpackage_count="1" :workpackage="extend_workpackage" :zoom="2" />
          </template>
        </Waggon>
        <!-- <StandardDataField placeholder="Amount of empty wagons" width="25%" height="26px" text_color="white"
          type="number" :value="amount_of_waggons" @changeValue="amount_of_waggons = $event;" /> -->
      </StandardFlexBox>
      <StandardFlexBox max_height="100px" height="100px" v-if="next_waggon">
        <Waggon @click.native="insertIntoWagon()" :workpackage_count="next_waggon.tworkpackages.length + 1" :zoom="2" style="cursor: pointer;">
          <template #content>
            <div class="token-view" style="cursor: pointer; font-size: large;">
              <TText v-if="reference.before" value="Previous Wagon" />
              <TText v-else value="Next Wagon" />
            </div>
            <!-- extend_workpackage -->
            <Workpackage v-for="(workpackage) in getUObjects({ type: `tworkpackages`, ids: next_waggon.tworkpackages })"
              :key="`nextwaggontworkpackages${workpackage.id}`" :workpackage_count="next_waggon.tworkpackages.length + 1" :workpackage="workpackage" :zoom="2" />
            <Workpackage :workpackage_count="next_waggon.tworkpackages.length + 1" :workpackage="extend_workpackage" :zoom="2" />
          </template>
        </Waggon>
      </StandardFlexBox>
    </template>
  </SideBar>
</template>

<script>
import store from '@/store/index'

import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'

import { AddTWaggonMixin } from '@/mixins/AddTWaggon.mixin.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_index', 'tworkpackage_id', 'reference'],
  components: {
    SideBar,
    Activator,
  },
  mixins: [
    AddTWaggonMixin
  ],
  data: () => ({
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    extend_workpackage(){
      let wp = JSON.parse(JSON.stringify(this.getUObject({ type: 'tworkpackages', id: this.tworkpackage_id })));
      wp.workpackage_part++;
      return wp;
    },
    next_waggon(){
      const taktarea = this.getUObject({ type: 'taktareas', id: this.taktarea_id });
      if (this.reference.before && this.twaggon_index > 0) {
        return this.getUObject({ type: 'twaggons', id: taktarea.twaggons[this.twaggon_index - 1] });
      }
      if (!this.reference.before && taktarea.twaggons.length > this.twaggon_index + 1) {
        return this.getUObject({ type: 'twaggons', id: taktarea.twaggons[this.twaggon_index + 1] });
      }
      return false;
    }
  },
  methods: {
    ...mapActions('SnackBar', [
      'requestSnackbarCreate'
    ]),
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookup'
    ]),
    extendWorkpackageWithNewWaggon(){
      let pos_mod = 1;
      if (!this.reference.before) {
        pos_mod = 2;
      }
      this.requestSnackbarCreate({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.reference.id},
          {extendwp: ''},
          {showWithEntitiesNormalized: ''}
        ],
        u_object: {
          waggon_payload: {position: parseInt(this.twaggon_index) + pos_mod},
          twp_ids: [this.$route.params.tworkpackage_id]
        },
        reference: this.reference,
        selector: 'reference'
      }).then((payload) => {
        this.createUObject(payload).then(() => {
          this.updateCalenderLookup(this.project_id)
        })
      })
    },
    insertIntoWagon(){
      let u_object = JSON.parse(JSON.stringify(this.extend_workpackage));
      // iterater over all step types from this.$store.state.Ultra.step_types_full
      this.$store.state.Ultra.step_types_full.forEach((step_type) => {
        const step_ids = JSON.parse(JSON.stringify(u_object[step_type]));
        u_object[step_type] = [];
        // iterate over all steps of the current step type
        step_ids.forEach((step_id) => {
          const step = this.getUObject({ type: step_type, id: step_id });
          u_object[step_type].push(step);
        });
      });

      this.requestSnackbarCreate({
        url: [
          {projects: this.project_id},
          {trains: this.train_id},
          {taktareas: this.taktarea_id},
          {twaggons: this.next_waggon.id},
          {tworkpackages: ''},
          {showWithEntitiesNormalized: ''}
        ],
        u_object: u_object,
      }).then((payload) => {
        this.createUObject(payload);
      });

    },
  },
  created() {
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters['Project/isEditMode']) {
      store.dispatch('Project/enterEditMode', { project_id: to.params.project_id });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch('Project/setInsertingTrain', false);
    next();
  },
}
</script>
<style>

</style>
